<template>
  <div>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="2">
          <v-menu transition="scale-transition" offset-y v-model="dateMenu">
            <template v-slot:activator="{ on }">
              <v-text-field label="Month" hide-details dense readonly v-on="on" v-model="monthAsDate" outlined append-icon="mdi-menu-down" @click:append="dateMenu=true"/>
            </template>
            <v-date-picker v-model="month" type="month" no-title @change="refresh"/>
          </v-menu>
        </v-col>
        <v-col cols="1"/>
        <v-col cols="2" align-self="center">
          <v-btn-toggle v-model="view" mandatory>
            <v-btn small>Printed Form</v-btn>
            <v-btn small>Online Form</v-btn>
          </v-btn-toggle>
        </v-col>
        <v-col cols="1"/>
        <v-col align-self="center">
          <template v-if="company.permissions.includes('excise.file')">
            <v-btn v-if="month>periodEnd" color="primary" small @click="file=true">Mark as filed</v-btn>
            <span v-else style="cursor:pointer" @click="unfile=true">
              Filed to end of {{periodEnd | formatDate}}
            </span>
            <reports-ontario-spirits-file v-model="file" @filed="periodEnd=$event"/>
            <reports-ontario-spirits-unfile v-model="unfile" @filed="periodEnd=$event"/>
          </template>
        </v-col>
        <v-col class="text-right pr-2">
          <v-btn icon @click="print"><v-icon>mdi-printer</v-icon></v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="mx-4 pa-4 overflow-y" height="calc(100vh - 180px)">
      <div v-show="view===0" v-html="printReturn(false)"/>
      <div v-show="view===1" v-html="onlineForm(false)"/>
    </v-card>
  </div>
</template>

<script>
import {format,add} from 'date-fns'
import ReportsOntarioSpiritsFile from '@/views/provinces/ON/reports/ReportsOntarioSpiritsFile'
import ReportsOntarioSpiritsUnfile from '@/views/provinces/ON/reports/ReportsOntarioSpiritsUnfile'
import printHtml from '@/mixins/printHtml'

export default {
  name: 'ReportsOntarioSpirits',
  mixins: [printHtml],
  components: {ReportsOntarioSpiritsFile,ReportsOntarioSpiritsUnfile},
  data() {
    return {
      dateMenu: false,
      month: '',
      view: 0,
      report: null,
      file: false,
      unfile: false,
      periodEnd: ''
    }
  },
  computed: {
    monthAsDate() {
      return this.$formatDate(this.month+'-01', 'MMMM, yyyy');
    },
    company() {
      return this.$store.getters.company;
    }
  },
  async created() {
    this.$emit('name', 'Ontario Spirits Return')
    this.month = format(add(new Date(), {months:-1}), 'yyyy-MM');
    this.refresh();
  },
  methods: {
    async refresh() {
      const results = await this.$apiCall(`query ReportsOntarioSpirits($date:Date!) {
                                              ontarioPreferences {
                                                mofPeriodEnd
                                              }
                                             ontarioSpiritsReport(date:$date) {
                                               scheduleA {spirits,spiritsCoolers},
                                               mainReturn
                                             }
                                           }`,
                                           {date:this.month+'-01'});
      if (!results.error) {
        this.periodEnd = results.data.ontarioPreferences.mofPeriodEnd;
        this.report = results.data.ontarioSpiritsReport;
      }
    },

    printReturn(print) {
      if (!this.report)
        return '';

      return `<style>
                @page {size:portrait}
                .osr-return {font-family: Roboto, sans-serif; font-size:14px;width:100%;border-spacing:0;border-collapse:collapse}
                .osr-return .title {font-weight:700;font-size:18px;text-align:left}
                .osr-return .sub-title {text-align:left}
                .osr-return tbody tr {
                  vertical-align:middle;
                }
                .osr-return tbody tr:last-child {
                  border-bottom:2px solid #000;
                }
                .osr-return tbody td {
                  padding:8px;
                  border:1px solid #888;
                }
                .osr-return .main td:nth-child(1) {
                  width:25px;
                  text-align:center;
                  border-left:2px solid #000;
                }
                .osr-return .main td:nth-child(2) {
                  width:700px;
                }
                .osr-return .main td:nth-child(3) {
                  width:25px;
                  text-align:center;
                }
                .osr-return .main td:nth-child(4) {
                  width:20px;
                  text-align:center;
                  border-right:none;
                }
                .osr-return .main td:nth-child(5) {
                  width:80px;
                  text-align:right;
                  border-right:none;
                  border-left:none;
                }
                .osr-return .main td:nth-child(6) {
                  width:20px;
                  text-align:center;
                  border-left:none;
                  border-right:2px solid #000;
                }
                .osr-return .main .header td {
                  width:950px;
                  text-align:left;
                  font-weight:bold;
                  border-top:2px solid #000;
                  border-right:2px solid #000;
                }
                .osr-return .schedule-a td:nth-child(1) {
                  width:25px;
                  text-align:center;
                  border-left:2px solid #000;
                }
                .osr-return .schedule-a td:nth-child(2) {
                  width:450px;
                }
                .osr-return .schedule-a td:nth-child(3) {
                  width:25px;
                  text-align:center;
                }
                .osr-return .schedule-a td:nth-child(4) {
                  width:150px;
                  text-align:right;
                }
                .osr-return .schedule-a td:nth-child(5) {
                  width:150px;
                  text-align:right;
                  border-right:2px solid #000;
                }
                .osr-return .schedule-a .header {
                  border-top:2px solid #000;
                  font-weight:bold;
                }
                .osr-return .schedule-a .header td:nth-child(1) {
                  width:500px;
                  text-align:left;
                }
                .osr-return .schedule-a .header td:nth-child(2) {
                  width:250px;
                  text-align:center;
                }
                .osr-return .schedule-a .header td:nth-child(3) {
                  width:250px;
                  text-align:center;
                  border-right:2px solid #000;
                }
                .osr-return .schedule-a .total {
                  padding-left:30px;
                }
                .page-break {
                  page-break-before: always;
                }
                .page-line {
                  border-top:thin solid #ccc;
                  margin-top: 50px;
                  margin-bottom: 50px;
                }
              </style>
              <table class="osr-return">
                <thead>
                  <tr>
                    <th colspan="6" class="title">Spirits and Spirits Cooler Return</th>
                  </tr>
                  <tr>
                    <th colspan="6" class="sub-title">${this.monthAsDate}</th>
                  </tr>
                  <tr><th colspan="6">&nbsp;</</th></tr>
                </thead>
                <tbody class="main">
                  <tr class="header">
                    <td colspan="6">Basic Tax</td>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>Taxable Distribution <small>(by sale) - add lines 1A and 1B from Schedule A</small></td>
                    <td>1</td>
                    <td>$</td>
                    <td>${this.number(0, 2)}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Taxable Distribution <small>(other than by sale) - add lines 2A and 2B from Schedule A</small></td>
                    <td>2</td>
                    <td>$</td>
                    <td>${this.number(1, 2)}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Spirits and Spirits Coolers Basic Tax Rate</td>
                    <td>3</td>
                    <td></td>
                    <td>${this.number(2, 4)}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Spirits and Spirits Coolers Basic Tax Payable - <small>(Line 1 x Line 3) + (Line 2 x Line 3)</small></td>
                    <td>4</td>
                    <td>$</td>
                    <td>${this.number(3, 2)}</td>
                    <td></td>
                  </tr>
                  <tr class="header">
                    <td colspan="6">Volume Tax</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>Spirits Taxable Distribution <small>(by sale) - line 10A from Schedule A</small></td>
                    <td>5</td>
                    <td></td>
                    <td>${this.number(4, 3)}</td>
                    <td>L</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>Spirits Taxable Distribution <small>(other than by sale) - line 11A from Schedule A</small></td>
                    <td>6</td>
                    <td></td>
                    <td>${this.number(5, 3)}</td>
                    <td>L</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>Spirits Volume Tax Rate</td>
                    <td>7</td>
                    <td></td>
                    <td>${this.number(6, 4)}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>Spirits Volume Tax Payable - <small>(Line 5 x Line 7) + (Line 6 x Line 7)</small></td>
                    <td>8</td>
                    <td>$</td>
                    <td>${this.number(7, 2)}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td>Spirits Cooler Taxable Distribution <small>(by sale) - line 10B from Schedule A</small></td>
                    <td>9</td>
                    <td></td>
                    <td>${this.number(8, 3)}</td>
                    <td>L</td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>Spirits Cooler Taxable Distribution <small>(other than by sale) - line 11B from Schedule A</small></td>
                    <td>10</td>
                    <td></td>
                    <td>${this.number(9, 3)}</td>
                    <td>L</td>
                  </tr>
                  <tr>
                    <td>11</td>
                    <td>Spirits Cooler Volume Tax Rate</td>
                    <td>11</td>
                    <td></td>
                    <td>${this.number(10, 4)}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>12</td>
                    <td>Spirits Cooler Volume Tax Payable - <small>(Line 9 x Line 11) + (Line 10 x Line 11)</small></td>
                    <td>12</td>
                    <td>$</td>
                    <td>${this.number(11, 2)}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>13</td>
                    <td>Volume Tax Payable - <small>add lines 8 and 12</small></td>
                    <td>13</td>
                    <td>$</td>
                    <td>${this.number(12, 2)}</td>
                    <td></td>
                  </tr>
                  <tr class="header">
                    <td colspan="6">Environmental Tax</td>
                  </tr>
                  <tr>
                    <td>14</td>
                    <td>Non-Refillable Containers <small>(by sale)</small></td>
                    <td>14</td>
                    <td></td>
                    <td>${this.number(13, 0)}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>15</td>
                    <td>Non-Refillable Containers <small>(other than by sale)</small></td>
                    <td>15</td>
                    <td></td>
                    <td>${this.number(14, 0)}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>16</td>
                    <td>Environmental Tax Rate</td>
                    <td>16</td>
                    <td></td>
                    <td>${this.number(15, 4)}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>17</td>
                    <td>Environmental Tax Payable - <small>(Line 14 x Line 16) + (Line 15 x Line 16)</small></td>
                    <td>17</td>
                    <td>$</td>
                    <td>${this.number(16, 2)}</td>
                    <td></td>
                  </tr>
                  <tr class="header">
                    <td colspan="6">Tax Due Calculation</td>
                  </tr>
                  <tr>
                    <td>18</td>
                    <td>Total Tax Payable - <small>add lines 4, 13 and 17</small></td>
                    <td>18</td>
                    <td>$</td>
                    <td>${this.number(17, 2)}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>19</td>
                    <td>Adjustments</td>
                    <td>19</td>
                    <td>$</td>
                    <td>${this.number(18, 2)}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>20</td>
                    <td><strong>Tax Due (or Credit)</strong> - <small>add lines 18 and 19</small></td>
                    <td>20</td>
                    <td>$</td>
                    <td>${this.number(19, 2)}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>21</td>
                    <td>Previous Balance</td>
                    <td>21</td>
                    <td>$</td>
                    <td>${this.number(20, 2)}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>22</td>
                    <td><strong>Total Due (or Credit)</strong> - <small>add lines 20 and 21</small></td>
                    <td>22</td>
                    <td>$</td>
                    <td>${this.number(21, 2)}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>23</td>
                    <td><strong>Payment Amount</strong></td>
                    <td>23</td>
                    <td>$</td>
                    <td>${this.number(22, 2)}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
              <div class="${print?'page-break':'page-line'}"></div>
              <table class="osr-return">
                <thead>
                  <tr>
                    <th colspan="5" class="title">Schedule A - Product Distribution Report</th>
                  </tr>
                  <tr>
                    <th colspan="5" class="sub-title">${this.monthAsDate}</th>
                  </tr>
                  <tr><th colspan="5">&nbsp;</</th></tr>
                  </thead>
                  <tbody class="schedule-a">
                    <tr class="header">
                      <td colspan="3">Product Distribution</td>
                      <td>A<br/>Spirits</td>
                      <td>B<br/>Spirits Coolers</td>
                    </tr>
                  <tr class="header">
                    <td colspan="3">Taxable Distribution ($)</td>
                    <td>($)</td>
                    <td>($)</td>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>Taxable Distribution <small>(by sale)</small></td>
                    <td>1</td>
                    <td>${this.dollars(true, 0)}</td>
                    <td>${this.dollars(false, 0)}</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Taxable Distribution <small>(other than by sale)</small></td>
                    <td>2</td>
                    <td>${this.dollars(true, 1)}</td>
                    <td>${this.dollars(false, 1)}</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td class="total">Total Taxable Distribution</td>
                    <td>3</td>
                    <td>${this.dollars(true, 2)}</td>
                    <td>${this.dollars(false, 2)}</td>
                  </tr>
                  <tr class="header">
                    <td colspan="3">Non-Taxable Distribution ($)</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Direct Delivery Sales to Licensees</td>
                    <td>4</td>
                    <td>${this.dollars(true, 3)}</td>
                    <td>${this.dollars(false, 3)}</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>Duty Free Sales in Ontario</td>
                    <td>5</td>
                    <td>${this.dollars(true, 4)}</td>
                    <td>${this.dollars(false, 4)}</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>Other LCBO Sales</td>
                    <td>6</td>
                    <td>${this.dollars(true, 5)}</td>
                    <td>${this.dollars(false, 5)}</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>Exports</td>
                    <td>7</td>
                    <td>${this.dollars(true, 6)}</td>
                    <td>${this.dollars(false, 6)}</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>Non-Taxable Distribution <small>(other than by sale)</small></td>
                    <td>8</td>
                    <td>${this.dollars(true, 7)}</td>
                    <td>${this.dollars(false, 7)}</td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td class="total">Total Non-Taxable Distribution</td>
                    <td>9</td>
                    <td>${this.dollars(true, 8)}</td>
                    <td>${this.dollars(false, 8)}</td>
                  </tr>
                  <tr class="header">
                    <td colspan="3">Taxable Distribution (Litres)</td>
                    <td>(Litres)</td>
                    <td>(Litres)</td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>Taxable Distribution <small>(by sale)</small></td>
                    <td>10</td>
                    <td>${this.litres(true, 9)}</td>
                    <td>${this.litres(false, 9)}</td>
                  </tr>
                  <tr>
                    <td>11</td>
                    <td>Taxable Distribution <small>(other than by sale)</small></td>
                    <td>11</td>
                    <td>${this.litres(true, 10)}</td>
                    <td>${this.litres(false, 10)}</td>
                  </tr>
                  <tr>
                    <td>12</td>
                    <td class="total">Total Taxable Distribution</td>
                    <td>12</td>
                    <td>${this.litres(true, 11)}</td>
                    <td>${this.litres(false, 11)}</td>
                  </tr>
                  <tr class="header">
                    <td colspan="3">Non-Taxable Distribution (Litres)</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>13</td>
                    <td>Direct Delivery Sales to Licensees</td>
                    <td>13</td>
                    <td>${this.litres(true, 12)}</td>
                    <td>${this.litres(false, 12)}</td>
                  </tr>
                  <tr>
                    <td>14</td>
                    <td>Duty Free Sales in Ontario</td>
                    <td>14</td>
                    <td>${this.litres(true, 13)}</td>
                    <td>${this.litres(false, 13)}</td>
                  </tr>
                  <tr>
                    <td>15</td>
                    <td>Other LCBO Sales</td>
                    <td>15</td>
                    <td>${this.litres(true, 14)}</td>
                    <td>${this.litres(false, 14)}</td>
                  </tr>
                  <tr>
                    <td>16</td>
                    <td>Exports</td>
                    <td>16</td>
                    <td>${this.litres(true, 15)}</td>
                    <td>${this.litres(false, 15)}</td>
                  </tr>
                  <tr>
                    <td>17</td>
                    <td>Non-Taxable Distribution <small>(other than by sale)</small></td>
                    <td>17</td>
                    <td>${this.litres(true, 16)}</td>
                    <td>${this.litres(false, 16)}</td>
                  </tr>
                  <tr>
                    <td>18</td>
                    <td class="total">Total Non-Taxable Distribution</td>
                    <td>18</td>
                    <td>${this.litres(true, 17)}</td>
                    <td>${this.litres(false, 17)}</td>
                  </tr>
                </tbody>
              </table>`;
    },

    onlineForm(print) {
      if (!this.report)
        return '';

      return `<style>
                @page {size:landscape}
                .osr-online {font-family: Roboto, sans-serif; font-size:14px;width:100%;border-spacing:0;border-collapse:collapse}
                .osr-online .title {font-weight:700;text-align:left;font-size:18px;border-bottom:1px solid #888}
                .osr-online .sub-title {padding-top:10px;text-align:left;font-weight:700;border-bottom:3px solid #000}
                .osr-online .heading {padding-top:20px;text-align:left;font-weight:700}
                .osr-online .col1 {width:34%}
                .osr-online .col2 {width:14%}
                .osr-online .col3 {width:4%}
                .osr-online .col4 {width:34%}
                .osr-online .col5 {width:14%}
                .osr-online .box {border:1px solid #888; padding:5px; text-align:right}
                .osr-online .shaded {background-color:#eee; padding:5px; text-align:right}
                .osr-online .spacer {height:10px}
                .page-break {
                  page-break-before: always;
                }
                .page-line {
                  border-top:thin solid #ccc;
                  margin-top: 50px;
                  margin-bottom: 50px;
                }
              </style>
              ${this.onlineFormFirstSteps(true)}
              <div class="${print?'page-break':'page-line'}"></div>
              ${this.onlineFormFirstSteps(false)}
              <div class="${print?'page-break':'page-line'}"></div>
              <table class="osr-online">
                <tbody>
                  <tr>
                    <td colspan="5" class="title">Step 3/5 -Environmental Tax</td>
                  </tr>
                  <tr>
                    <td colspan="5" class="sub-title">SPIRITS AND SPIRITS COOLER RETURN - ${this.monthAsDate}</td>
                  </tr>
                  <tr>
                    <td colspan="5" class="heading">Environmental Tax</td>
                  </tr>
                  <tr class="spacer"><td colspan="5"/></tr>
                  <tr>
                    <td class="col1">14. Non-Refillable Containers (by sale)</td>
                    <td class="col2 box">${this.number(13, 0)}</td>
                    <td class="col3"/>
                    <td class="col4"></td>
                    <td class="col5"></td>
                  </tr>
                  <tr class="spacer"><td colspan="5"/></tr>
                  <tr>
                    <td class="col1">15. Non-Refillable Containers (other than by sale)</td>
                    <td class="col2 box">${this.number(14, 0)}</td>
                    <td class="col3"/>
                    <td class="col4"></td>
                    <td class="col5"></td>
                  </tr>
                </table>
              <div class="${print?'page-break':'page-line'}"></div>
              <table class="osr-online">
                <tbody>
                  <tr>
                    <td colspan="5" class="title">Step 4/5 -Tax Due Calculation and Payment Amount</td>
                  </tr>
                  <tr>
                    <td colspan="5" class="sub-title">SPIRITS AND SPIRITS COOLER RETURN - ${this.monthAsDate}</td>
                  </tr>
                  <tr class="spacer"><td colspan="5"/></tr>
                  <tr>
                    <td colspan="2" class="heading">Tax Due Calculation</td>
                    <td/>
                    <td colspan="2" class="heading">Payment Amount</td>
                  </tr>
                  <tr class="spacer"><td colspan="5"/></tr>
                  <tr>
                    <td class="col1">18. Total Tax Payable</td>
                    <td class="col2 shaded">${this.number(17, 2)}</td>
                    <td class="col3"/>
                    <td class="col4">Payment Amount</td>
                    <td class="col5 box">${this.number(22, 2)}</td>
                  </tr>
                  <tr class="spacer"><td colspan="5"/></tr>
                  <tr>
                    <td class="col1">19. Adjustments</td>
                    <td class="col2 box">${this.number(18, 2)}</td>
                    <td class="col3"/>
                    <td class="col4"></td>
                    <td class="col5"></td>
                  </tr>
                  <tr class="spacer"><td colspan="5"/></tr>
                  <tr>
                    <td class="col1">20. Tax Due (or Credit)</td>
                    <td class="col2 shaded">${this.number(21, 2)}</td>
                    <td class="col3"/>
                    <td class="col4"></td>
                    <td class="col5"></td>
                  </tr>
                </table>
                <div class="${print?'page-break':'page-line'}"></div>
                <table class="osr-online">
                  <tbody>
                    <tr>
                      <td colspan="5" class="title">Step 5/5 - Summary</td>
                    </tr>
                    <tr>
                      <td colspan="5" class="sub-title">SPIRITS AND SPIRITS COOLER RETURN - ${this.monthAsDate}</td>
                    </tr>
                    <tr class="spacer"><td colspan="5"/></tr>
                    <tr>
                      <td colspan="5" class="sub-title">BASIC TAX</td>
                    </tr>
                    <tr class="spacer"><td colspan="5"/></tr>
                    <tr class="spacer"><td colspan="5"/></tr>
                    <tr>
                      <td class="col1">1. Taxable Distribution (by sale)</td>
                      <td class="col2 shaded">${this.number(0, 2)}</td>
                      <td class="col3"/>
                      <td class="col4">3. Basic Tax Rate</td>
                      <td class="col5 shaded">${this.number(2, 4)}</td>
                    </tr>
                    <tr class="spacer"><td colspan="5"/></tr>
                    <tr>
                      <td class="col1">2. Taxable Distribution (other than by sale)</td>
                      <td class="col2 shaded">${this.number(1, 2)}</td>
                      <td class="col3"/>
                      <td class="col4"><strong>4. Basic Tax Payable</strong></td>
                      <td class="col5 shaded">${this.number(3, 2)}</td>
                    </tr>
                    <tr>
                      <td colspan="5" class="sub-title">VOLUME TAX</td>
                    </tr>
                    <tr class="spacer"><td colspan="5"/></tr>
                    <tr class="spacer"><td colspan="5"/></tr>
                    <tr>
                      <td class="col1">5. Spirits Taxable Distribution (by sale)</td>
                      <td class="col2 shaded">${this.number(4, 3)}</td>
                      <td class="col3"/>
                      <td class="col4">9. Spirits Cooler Taxable Distribution (by sale)</td>
                      <td class="col5 shaded">${this.number(8, 3)}</td>
                    </tr>
                    <tr class="spacer"><td colspan="5"/></tr>
                    <tr>
                      <td class="col1">6. Spirits Taxable Distribution (other than by sale)</td>
                      <td class="col2 shaded">${this.number(5, 3)}</td>
                      <td class="col3"/>
                      <td class="col4">10. Spirits Cooler Taxable Distribution (other than by sale)</td>
                      <td class="col5 shaded">${this.number(9, 3)}</td>
                    </tr>
                    <tr class="spacer"><td colspan="5"/></tr>
                    <tr>
                      <td class="col1">7. Spirits Volume Tax Rate</td>
                      <td class="col2 shaded">${this.number(6, 4)}</td>
                      <td class="col3"/>
                      <td class="col4">11. Spirits Cooler Volume Tax Rate</td>
                      <td class="col5 shaded">${this.number(10, 4)}</td>
                    </tr>
                    <tr class="spacer"><td colspan="5"/></tr>
                    <tr>
                      <td class="col1">8. Spirits Volume Tax Payable</td>
                      <td class="col2 shaded">${this.number(7, 2)}</td>
                      <td class="col3"/>
                      <td class="col4">12. Spirits Cooler Volume Tax Payable</td>
                      <td class="col5 shaded">${this.number(11, 2)}</td>
                    </tr>
                    <tr class="spacer"><td colspan="5"/></tr>
                    <tr>
                      <td class="col1"></td>
                      <td class="col2"></td>
                      <td class="col3"/>
                      <td class="col4"><strong>13. Volume Tax Payable</strong></td>
                      <td class="col5 shaded">${this.number(12, 2)}</td>
                    </tr>
                    <tr>
                      <td colspan="5" class="sub-title">ENVIRONMENTAL TAX</td>
                    </tr>
                    <tr class="spacer"><td colspan="5"/></tr>
                    <tr class="spacer"><td colspan="5"/></tr>
                    <tr>
                      <td class="col1">14. Non-Refillable Containers (by sale)</td>
                      <td class="col2 shaded">${this.number(13, 0)}</td>
                      <td class="col3"/>
                      <td class="col4">16. Environmental Tax Rate</td>
                      <td class="col5 shaded">${this.number(15, 4)}</td>
                    </tr>
                    <tr class="spacer"><td colspan="5"/></tr>
                    <tr>
                      <td class="col1">15. Non-Refillable Containers (other than by sale)</td>
                      <td class="col2 shaded">${this.number(14, 0)}</td>
                      <td class="col3"/>
                      <td class="col4"><strong>17. Environmental Tax Payable</strong></td>
                      <td class="col5 shaded">${this.number(16, 2)}</td>
                    </tr>
                    <tr>
                      <td colspan="5" class="sub-title">TAX DUE CALCULATION</td>
                    </tr>
                    <tr class="spacer"><td colspan="5"/></tr>
                    <tr class="spacer"><td colspan="5"/></tr>
                    <tr>
                      <td class="col1">18. Total Tax Payable</td>
                      <td class="col2 shaded">${this.number(17, 2)}</td>
                      <td class="col3"/>
                      <td class="col4"></td>
                      <td class="col5"></td>
                    </tr>
                    <tr class="spacer"><td colspan="5"/></tr>
                    <tr>
                      <td class="col1">19. Adjustments</td>
                      <td class="col2 shaded">${this.number(18, 2)}</td>
                      <td class="col3"/>
                      <td class="col4"></td>
                      <td class="col5"></td>
                    </tr>
                    <tr class="spacer"><td colspan="5"/></tr>
                    <tr>
                      <td class="col1">20. Tax Due (or Credit)</td>
                      <td class="col2 shaded">${this.number(19, 2)}</td>
                      <td class="col3"/>
                      <td class="col4"></td>
                      <td class="col5"></td>
                    </tr>
                    <tr>
                      <td colspan="5" class="sub-title">PAYMENT AMOUNT</td>
                    </tr>
                    <tr class="spacer"><td colspan="5"/></tr>
                    <tr class="spacer"><td colspan="5"/></tr>
                    <tr>
                      <td class="col1">Payment amount</td>
                      <td class="col2 shaded">${this.number(22, 2)}</td>
                      <td class="col3"/>
                      <td class="col4"></td>
                      <td class="col5"></td>
                    </tr>
                  </table>
              `;
    },

    onlineFormFirstSteps(spirits) {
      return `<table class="osr-online">
                <tbody>
                  <tr>
                    <td colspan="5" class="title">Step ${spirits?'1':'2'}/5 - Spirits ${spirits?'':'Coolers'}</td>
                  </tr>
                  <tr>
                    <td colspan="5" class="sub-title">SPIRITS AND SPIRITS COOLER RETURN - ${this.monthAsDate}</td>
                  </tr>
                  <tr>
                    <td colspan="5" class="heading">Schedule A: Product Distribution Report - Spirits ${spirits?'':'Coolers'}</td>
                  </tr>
                  <tr>
                    <td colspan="2" class="sub-title">PRODUCT DISTRIBUTION ($)</td>
                    <td/>
                    <td colspan="2" class="sub-title col3">PRODUCT DISTRIBUTION (LITRES)</td>
                  </tr>
                  <tr>
                    <td colspan="2" class="heading">Taxable Distribution</td>
                    <td/>
                    <td colspan="2" class="heading">Taxable Distribution</td>
                  </tr>
                  <tr class="spacer"><td colspan="5"/></tr>
                  <tr>
                    <td class="col1">1. Taxable Distribution (by sale)</td>
                    <td class="col2 box">${this.dollars(spirits, 0)}</td>
                    <td class="col3"/>
                    <td class="col4">10. Taxable Distribution (by sale)</td>
                    <td class="col5 box">${this.litres(spirits, 9)}</td>
                  </tr>
                  <tr class="spacer"><td colspan="5"/></tr>
                  <tr>
                    <td class="col1">2. Taxable Distribution (other than by sale)</td>
                    <td class="col2 box">${this.dollars(spirits, 1)}</td>
                    <td class="col3"/>
                    <td class="col4">11. Taxable Distribution (other than by sale)</td>
                    <td class="col5 box">${this.litres(spirits, 10)}</td>
                  </tr>
                  <tr class="spacer"><td colspan="5"/></tr>
                  <tr>
                    <td class="col1">3. Total Taxable Distribution</td>
                    <td class="col2 shaded">${this.dollars(spirits, 2)}</td>
                    <td class="col3"/>
                    <td class="col4">12. Total Taxable Distribution</td>
                    <td class="col5 shaded">${this.litres(spirits, 11)}</td>
                  </tr>
                  <tr>
                    <td colspan="2" class="heading">Non-Taxable Distribution</td>
                    <td/>
                    <td colspan="2" class="heading">Non-Taxable Distribution</td>
                  </tr>
                  <tr class="spacer"><td colspan="5"/></tr>
                  <tr>
                    <td class="col1">4. Direct Delivery Sales to Licensees</td>
                    <td class="col2 box">${this.dollars(spirits, 3)}</td>
                    <td class="col3"/>
                    <td class="col4">13. Direct Delivery Sales to Licensees</td>
                    <td class="col5 box">${this.litres(spirits, 12)}</td>
                  </tr>
                  <tr class="spacer"><td colspan="5"/></tr>
                  <tr>
                    <td class="col1">5. Duty Free Sales in Ontario</td>
                    <td class="col2 box">${this.dollars(spirits, 4)}</td>
                    <td class="col3"/>
                    <td class="col4">14. Duty Free Sales in Ontario</td>
                    <td class="col5 box">${this.litres(spirits, 13)}</td>
                  </tr>
                  <tr class="spacer"><td colspan="5"/></tr>
                  <tr>
                    <td class="col1">6. Other LCBO Sales</td>
                    <td class="col2 box">${this.dollars(spirits, 5)}</td>
                    <td class="col3"/>
                    <td class="col4">15. Other LCBO Sales</td>
                    <td class="col5 box">${this.litres(spirits, 14)}</td>
                  </tr>
                  <tr class="spacer"><td colspan="5"/></tr>
                  <tr>
                    <td class="col1">7. Exports</td>
                    <td class="col2 box">${this.dollars(spirits, 6)}</td>
                    <td class="col3"/>
                    <td class="col4">16. Exports</td>
                    <td class="col5 box">${this.litres(spirits, 15)}</td>
                  </tr>
                  <tr class="spacer"><td colspan="5"/></tr>
                  <tr>
                    <td class="col1">8. Non-Taxable Distribution (other than by sale</td>
                    <td class="col2 box">${this.dollars(spirits, 7)}</td>
                    <td class="col3"/>
                    <td class="col4">17. Non-Taxable Distribution (other than by sale</td>
                    <td class="col5 box">${this.litres(spirits, 16)}</td>
                  </tr>
                  <tr class="spacer"><td colspan="5"/></tr>
                  <tr>
                    <td class="col1">9. Total Non-Taxable Distribution</td>
                    <td class="col2 shaded">${this.dollars(spirits, 8)}</td>
                    <td class="col3"/>
                    <td class="col4">18. Total Non-Taxable Distribution</td>
                    <td class="col5 shaded">${this.litres(spirits, 17)}</td>
                  </tr>
                </tbody>
              </table>
              `;
    },

    dollars(spirits, line) {
      const value = this.report.scheduleA[spirits ? 'spirits' : 'spiritsCoolers'][line];
      return this.$number(value, 2);
    },
    litres(spirits, line) {
      const value = this.report.scheduleA[spirits ? 'spirits' : 'spiritsCoolers'][line];
      return this.$number(value, 3);
    },
    number(line, precision) {
      return this.$number(this.report.mainReturn[line], precision);
    },

    async print() {
      this.printHtml('Ontario Spirits Return', this.view === 0 ? `${this.printReturn(true)}` : `${this.onlineForm(true)}`);
    }
  }
}
</script>